// imports
import Component from 'minsky-kit/js/components/Component';

// private statics

// class definition
export default class HistoryButton extends Component {
    // constructor
    constructor (args = {}, objectName = 'HistoryButton') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        if (document.referrer.split('?')[0].endsWith('docs')) {
            this.$el.innerHTML = Drupal.t('minskyString.article.label');
            this.$el.src = '/node/32'; // single: documents overview
        }
    }

    // methods
    refresh (...args) {
        super.refresh(...args);
    }

    show (...args) {
        super.show(...args);
    }

    destroy () {
        super.destroy();
    }

    // getters & setters
}

// Utils

// Event handlers
